import { ElementRef } from '@angular/core';
import { EMPTY } from 'rxjs';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { makeRecurringRequests } from 'NewAngular/utils/make-recurring-requests.util';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "NewAngular/services/core/ajax.service";
import * as i3 from "NewAngular/services/core/urls.service";
import * as i4 from "@angular/common";
function EsgNewsComponent_Conditional_0_div_13_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const article_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", article_r2.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(article_r2.title);
} }
function EsgNewsComponent_Conditional_0_div_13_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 16);
    i0.ɵɵlistener("click", function EsgNewsComponent_Conditional_0_div_13_a_3_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r3); const article_r2 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.redirectToNewsArticle(article_r2.internal_id)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const article_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", article_r2.title, " ");
} }
function EsgNewsComponent_Conditional_0_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 5);
    i0.ɵɵtemplate(2, EsgNewsComponent_Conditional_0_div_13_a_2_Template, 2, 2, "a", 13)(3, EsgNewsComponent_Conditional_0_div_13_a_3_Template, 2, 1, "a", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const article_r2 = ctx.$implicit;
    i0.ɵɵclassProp("news-row-highlighted", article_r2.isNew);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", article_r2.link);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !article_r2.link);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(article_r2.news_source);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(article_r2.eastern_news_date_formatted);
} }
function EsgNewsComponent_Conditional_0_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "div", 18);
    i0.ɵɵelementEnd();
} }
function EsgNewsComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3", 2);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 3)(5, "div", 4)(6, "div", 5);
    i0.ɵɵtext(7, "Headline");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 6);
    i0.ɵɵtext(9, "Wire");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 7);
    i0.ɵɵtext(11, "Time (ET)");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 8);
    i0.ɵɵtemplate(13, EsgNewsComponent_Conditional_0_div_13_Template, 8, 6, "div", 9);
    i0.ɵɵelementStart(14, "div", 10);
    i0.ɵɵlistener("fetchMoreItemsHandler", function EsgNewsComponent_Conditional_0_Template_div_fetchMoreItemsHandler_14_listener() { i0.ɵɵrestoreView(_r1); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.loadOlderArticles()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, EsgNewsComponent_Conditional_0_div_15_Template, 2, 0, "div", 11);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r3.securityName, " News");
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngForOf", ctx_r3.newsList);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.loading);
} }
export class EsgNewsComponent {
    constructor(accountsService, ajaxService, eltRef, urlsService) {
        this.accountsService = accountsService;
        this.ajaxService = ajaxService;
        this.eltRef = eltRef;
        this.urlsService = urlsService;
        this.fetchSubscription = null;
        this.NEW_ARTICLES_REFRESH_TIME = 30000; // 30 seconds
        this.MIN_NUM_ARTICLES = 5;
        this.exchangeSymbol = '';
        this.isAlive = true;
        this.loading = false;
        this.newsList = [];
        this.securityName = '';
        this.securityType = '';
        this.exchangeSymbol = this.eltRef.nativeElement.getAttribute('exchangeSymbol');
        this.securityName = this.eltRef.nativeElement.getAttribute('securityName');
        this.securityType = this.eltRef.nativeElement.getAttribute('securityType');
        this.makeRecurringRequestsForNewArticles();
        this.loadOlderArticles();
    }
    ngOnDestroy() {
        this.isAlive = false;
        if (this.fetchSubscription !== null) {
            this.fetchSubscription.unsubscribe();
        }
    }
    getESGNews(params) {
        const url = this.urlsService.getUrl(this.urlsService.ESG.NEWS, {}, params);
        return this.ajaxService.getDataObserveBody(url);
    }
    getParams() {
        return {
            exchangeSymbol: this.exchangeSymbol,
            securityType: this.securityType,
        };
    }
    /**
     * Gets older articles than the last article in newsArticles and appends them to newsList.
     */
    loadOlderArticles() {
        if (this.fetchSubscription) {
            this.fetchSubscription.unsubscribe();
        }
        const params = this.getParams();
        // Add to params the date of the last article to filter for older articles
        if (this.newsList.length > 0) {
            const lastItem = this.newsList.slice(-1)[0];
            params.olderThan = lastItem.news_date;
        }
        this.loading = true;
        this.fetchSubscription = this.getESGNews(params).subscribe({
            next: (response) => {
                const olderArticles = response.news;
                if (olderArticles.length === 0)
                    return;
                this.newsList = this.newsList.concat(olderArticles);
            },
            error: () => { },
            complete: () => {
                if (this.newsList.length !== 0) {
                    this.lastUpdatedTime = this.newsList[0].news_date;
                }
                this.loading = false;
            },
        });
    }
    /**
     * Gets newer articles than the most recent article in newsList, flags them as new & preappends
     * them to the top of the list.
     */
    makeRecurringRequestsForNewArticles() {
        const fetcher = () => {
            if (this.lastUpdatedTime) {
                const params = this.getParams();
                params.newerThan = this.lastUpdatedTime;
                return this.getESGNews(params);
            }
            // If this.lastUpdatedTime is not defined then we do not want to fetch new articles.
            // Return the empty observable which immediately completes without emitting a value.
            return EMPTY;
        };
        const fetchCallback = (newerArticles) => {
            // Flag new articles as new
            newerArticles.news.forEach(function (article) {
                // eslint-disable-next-line no-param-reassign
                article.isNew = true;
            });
            // Append articles to the top of the list
            this.newsList.unshift(...newerArticles.news);
            if (this.newsList.length !== 0) {
                this.lastUpdatedTime = this.newsList[0].news_date;
            }
        };
        makeRecurringRequests(this.NEW_ARTICLES_REFRESH_TIME, fetcher, fetchCallback, this.isAlive);
    }
    redirectToNewsArticle(articleId) {
        window.open(this.urlsService.getUrl(this.urlsService.NEWS.STORY, { articleId }), '_blank');
    }
}
EsgNewsComponent.ɵfac = function EsgNewsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EsgNewsComponent)(i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i2.AjaxService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i3.UrlsService)); };
EsgNewsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EsgNewsComponent, selectors: [["ycn-esg-news"]], standalone: false, decls: 1, vars: 1, consts: [[1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "news", "news-vertical-md"], [1, "news-header", 2, "margin-right", "-300px"], [1, "news-cell", "news-title"], [1, "news-cell", "news-source"], [1, "news-cell", "news-date"], [1, "news-body"], ["class", "news-row", 3, "news-row-highlighted", 4, "ngFor", "ngForOf"], ["ycnInfiniteScroll", "", 3, "fetchMoreItemsHandler"], ["class", "loader", 4, "ngIf"], [1, "news-row"], ["target", "_blank", 3, "href", 4, "ngIf"], ["href", "javascript:void(0)", 3, "click", 4, "ngIf"], ["target", "_blank", 3, "href"], ["href", "javascript:void(0)", 3, "click"], [1, "loader"], [1, "loader-spinner"]], template: function EsgNewsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, EsgNewsComponent_Conditional_0_Template, 16, 3, "div", 0);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.newsList.length >= ctx.MIN_NUM_ARTICLES ? 0 : -1);
    } }, dependencies: [i4.NgForOf, i4.NgIf], encapsulation: 2 });
